module.exports = __webpack_public_path__ + "img/av (5).75b8dfbd.png";